import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user && user !== false) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Berjaya log masuk");
      nav("/admin", { replace: true });
    } else {
      toast.error(res.error || "Login gagal");
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#050505] px-4 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-violet-600/15 blur-[120px] pointer-events-none" />
      <form
        onSubmit={onSubmit}
        data-testid="admin-login-form"
        className="relative w-full max-w-md rounded-2xl bg-[#0f0f12] border border-white/10 p-8 fade-up"
      >
        <Link to="/" className="flex items-baseline gap-0.5 mb-8">
          <span className="font-heading font-black text-2xl tracking-tighter text-white">AZMIEY</span>
          <span className="font-heading font-black text-2xl tracking-tighter text-violet-500">STORE</span>
        </Link>
        <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-violet-400 mb-2">
          Admin Panel
        </div>
        <h1 className="font-heading text-2xl font-bold mb-6">Log Masuk</h1>

        <label className="text-xs text-zinc-400 mb-1 block">Email</label>
        <div className="relative mb-4">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
          <Input
            data-testid="admin-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="pl-10 h-12 rounded-xl bg-[#121214] border-white/10 focus-visible:ring-violet-500 focus-visible:border-violet-500 text-white"
            placeholder="admin@azmieystore.com"
          />
        </div>

        <label className="text-xs text-zinc-400 mb-1 block">Password</label>
        <div className="relative mb-6">
          <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
          <Input
            data-testid="admin-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="pl-10 h-12 rounded-xl bg-[#121214] border-white/10 focus-visible:ring-violet-500 focus-visible:border-violet-500 text-white"
            placeholder="••••••••"
          />
        </div>

        <button
          type="submit"
          disabled={submitting}
          data-testid="admin-login-submit"
          className="w-full h-12 rounded-xl bg-violet-600 hover:bg-violet-500 disabled:opacity-60 transition-colors font-semibold text-white purple-glow"
        >
          {submitting ? "Memuat..." : "Log Masuk"}
        </button>

        <div className="mt-6 text-center">
          <Link to="/" className="text-xs text-zinc-500 hover:text-violet-400 transition-colors">
            ← Kembali ke laman utama
          </Link>
        </div>
      </form>
    </div>
  );
}
